import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import SlopeAnalysis from './slopeAnalysis'
import SlopeDirection from './slopeDirection'
import VisualAreaAnalysis from './visualAreaAnalysis'
import SkylineAnalysis from './skylineAnalysis'
import Perspective from './perspective'
import ShadeAnalysis from './shadeAnalysis'
import PlaneDistance from './planeDistanceMeasure'
import HeightMeasure from './heightMeasure'
import AreaMeasure from './areaMeasure'
import VolumeMeasure from './volumeMeasure'
import ElevationMeasure from './elevationMeasure'
import Modal from '@/components/Modal'
import useStore from '@/hooks/useStore'
import {
  AN1,
  AN1_MODAL_TITLE,
  AN2,
  AN2_MODAL_TITLE,
  AN3,
  AN3_MODAL_TITLE,
  AN4,
  AN4_MODAL_TITLE,
  AN5,
  AN5_MODAL_TITLE,
  AN6,
  AN6_MODAL_TITLE,
  ME1,
  ME2,
  ME3,
  ME4,
  ME5,
  MODAL_WIDTH400,
  // MODAL_WIDTH560,
  MODAL_WIDTH_AN1,
} from '@/components/Content/RightNavCtrl/data'

const AnalysisAndMeasure = forwardRef((props, ref) => {
  const rightNavCtrlStore = useStore('rightNavCtrlStore')
  const uiStore = useStore('uiStore')
  const { currentVisible } = rightNavCtrlStore
  const [visible, setVisible] = useState(false)

  const slopeAnalysisRef: any = useRef(null)
  const slopeAnalysisDirectionRef: any = useRef(null)

  useImperativeHandle(ref, () => ({
    handleDiffCloseModal,
  }))

  useEffect(() => {
    showAnalysisModal()
  }, [currentVisible])

  const showAnalysisModal = () => {
    switch (currentVisible) {
      case AN1:
      case AN2:
      case AN3:
      case AN4:
      case AN5:
      case AN6:
        setVisible(!!currentVisible)
        break
      default:
        setVisible(false)
        break
    }
  }

  const renderModalTitle = () => {
    switch (currentVisible) {
      case AN1:
        return AN1_MODAL_TITLE
      case AN2:
        return AN2_MODAL_TITLE
      case AN3:
        return AN3_MODAL_TITLE
      case AN4:
        return AN4_MODAL_TITLE
      case AN5:
        return AN5_MODAL_TITLE
      case AN6:
        return AN6_MODAL_TITLE
      default:
        return ''
    }
  }

  const renderModalWidth = () => {
    switch (currentVisible) {
      case AN1:
        return MODAL_WIDTH_AN1
      case AN2:
        return MODAL_WIDTH400
      case AN3:
        return MODAL_WIDTH400
      case AN4:
        return MODAL_WIDTH400
      case AN5:
        return MODAL_WIDTH400
      case AN6:
        return MODAL_WIDTH400
      default:
        return MODAL_WIDTH400
    }
  }

  const renderAnalysis = () => {
    switch (currentVisible) {
      case AN1:
        return <SlopeAnalysis ref={slopeAnalysisRef} />
      case AN2:
        return <SlopeDirection ref={slopeAnalysisDirectionRef} />
      case AN3:
        return <VisualAreaAnalysis />
      case AN4:
        return <SkylineAnalysis />
      case AN5:
        return <Perspective />
      case AN6:
        return <ShadeAnalysis />
      default:
        return ''
    }
  }

  const renderMeasure = () => {
    if (ME1 === currentVisible || ME2 === currentVisible || ME3 === currentVisible || ME4 === currentVisible || ME5 === currentVisible) {
      switch (currentVisible) {
        case ME1:
          return <PlaneDistance />
        case ME2:
          return <HeightMeasure />
        case ME3:
          return <AreaMeasure />
        case ME4:
          return <VolumeMeasure />
        case ME5:
          return <ElevationMeasure />
        default:
          return ''
      }
    }
  }

  const handleCloseModal = () => {
    rightNavCtrlStore.setCurrentVisible(undefined)
  }

  const handleDiffCloseModal = () => {
    clearAllAnalysisEntity()

    handleCloseModal()
  }

  const clearAllAnalysisEntity = () => {
    if (slopeAnalysisRef?.current?.handleClearAll) {
      slopeAnalysisRef.current.handleClearAll()
    }

    if (slopeAnalysisDirectionRef?.current?.handleClearAll) {
      slopeAnalysisDirectionRef.current.handleClearAll()
    }
  }

  return (
    <div>
      <Modal
        visible={visible}
        headerTitle={renderModalTitle()}
        handleClose={() => {
          handleDiffCloseModal()
        }}
        styles={{
          position: 'fixed',
          width: renderModalWidth(),
          top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
          left: `${uiStore.Content_Left_Width + 30}px`,
          zIndex: 10,
        }}
        isNotDragWithParent="dragModal"
      >
        {renderAnalysis()}
      </Modal>
      {renderMeasure()}
    </div>
  )
})
export default observer(AnalysisAndMeasure)
